import * as React from "react";
import { cn } from "@/lib/utils";

export const textareaClass =
  "flex min-h-[72px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs outline-none transition-[color,box-shadow] placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50";

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea className={cn(textareaClass, className)} ref={ref} {...props} />
));
Textarea.displayName = "Textarea";

export { Textarea };
